
export default {
  name: 'CustomPage',

  mounted() {
    this.$router.push('/')
  }
}
